// extracted by mini-css-extract-plugin
module.exports = {"makerWhite":"white"};